import { render } from "./PriceListAdmin.vue?vue&type=template&id=6bebed31"
import script from "./PriceListAdmin.vue?vue&type=script&lang=js"
export * from "./PriceListAdmin.vue?vue&type=script&lang=js"

import "./PriceListAdmin.vue?vue&type=style&index=0&id=6bebed31&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__